module.exports = __webpack_public_path__ + "assets/img/smartTV-module4-9.8ded1b36.jpg";